import * as adminActions from "./actions";
import UserManagement from "./pages";

export { UserManagement as default, adminActions };
